import "./App.css";
import NavBar from "./components/NavBar";
import Counter from "./components/Counter";
import BannerHowToBuy from "./components/BannerHowToBuy";
import Gallery from "./components/Gallery";
import { useEffect, useState, useRef } from "react";
import { HashConnect } from "hashconnect";
import { LedgerId } from "@hashgraph/sdk";
import Hedera from "./components/icons/Hedera";
import Brazil from "./components/icons/Brazil";
import Twitter from "./components/Twitter";
import Instagram from "./components/Instagram";
import HamburguerMenu from "./components/HamburguerMenu";
import Loading from "./components/Loading";
import Next from "./components/icons/Next";
import { Roadmap } from "./components/Roadmap";

function App() {
  const [paired, setPaired] = useState(false);
  const [pairingData, setPairingData] = useState(null);
  const [hashconnect, setHashconnect] = useState(null);
  const [isOpenHamburguer, setIsOpenHamburguer] = useState(false);
  const [visibleOpenHamburguer, setVisibleOpenHamburguer] = useState(false);
  const galleryRef = useRef(null);
  const roadmapRef = useRef(null);

  const toggleHamburguerMenu = () => {
    if (isOpenHamburguer) {
      setIsOpenHamburguer(false);
      setTimeout(() => {
        setVisibleOpenHamburguer(false);
      }, 200);
    } else {
      setIsOpenHamburguer(true);
      setVisibleOpenHamburguer(true);
    }
  };


  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const appMetadata = {
      name: "Hashguys",
      description: "Hashguys Description XDTORA",
      icons: [window.location.origin + "/assets/images/hashguys-logo.png"],
      url: window.location.origin,
    };

    const hashconnect = new HashConnect(
      LedgerId.TESTNET,
      "26bd4613517a8389c264807945ca5261",
      appMetadata,
      true
    );
    hashconnect.pairingEvent.on((newPairing) => {
      setPaired(true);
      setPairingData(newPairing);
    });

    hashconnect.disconnectionEvent.on((data) => {
      setPaired(false);
      setPairingData(null);
    });
    await hashconnect.init();
    setHashconnect(hashconnect);
  };

  const scrollToGallery = () => {
    toggleHamburguerMenu();
    galleryRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToRoadmap = () => {
    toggleHamburguerMenu();
    roadmapRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App">
      <meta name="keywords" content="hashguys,nft" />
      <NavBar hashconnect={hashconnect} paired={paired} toggleHamburguerMenu={toggleHamburguerMenu} />
      <HamburguerMenu
        isOpen={isOpenHamburguer}
        toggleHamburguerMenu={toggleHamburguerMenu}
        scrollToGallery={scrollToGallery}
        scrollToRoadmap={scrollToRoadmap}
        visibleOpenHamburguer={visibleOpenHamburguer}
      />
      <main>
        <section className="flex justify-center items-center mt-[25px] h-[580px] mb-[40px] lg:mb-[0px] lg:min-h-[900px] ">
          <Counter hashconnect={hashconnect} pairingData={pairingData} paired={paired} />
        </section>
        <section className="flex justify-center h-[670px] lg:h-[950px]  mb-[40px]">
          <BannerHowToBuy />
        </section>
        <section ref={galleryRef} id="gallery" className="flex md:ml-[30px] justify-center md:min-h-[940px] min-h-[590px] ">
          <Gallery />
        </section>
      </main>
      <section ref={roadmapRef} className="flex justify-center items-center h-[350px] lg:h-[550px]">
        <Roadmap />
      </section>
      <footer className="flex h-[40px] lg:h-[70px] items-center justify-between px-2 py-5 text-lg sm:px-16 bg-footer text-purple-light">
        <div className="flex items-center gap-2 text-12 lg:text-28">
          <span>Built on</span>
          <Hedera />
        </div>
        <div className="flex gap-2 lg:gap-4">
          <Twitter />
          <Instagram />
        </div>
        <div className="flex items-center gap-2 text-12 lg:text-28">
          <span>Made in</span>
          <Brazil />
        </div>
      </footer>
    </div>
  );
}

export default App;
